import { QueryFunctionContext, useInfiniteQuery } from "@tanstack/react-query";
import { configuration } from "src/configuration";
import { FetchError, GetTeamTaskItemsDto, queryKeys, useAccessToken } from "src/http";

const useGetTeamTaskItemSubtasksRequest = () => {
  const { getAccessToken } = useAccessToken();

  async function getTeamTaskItemSubtasksRequest({
    queryKey,
    pageParam: taskItemGuid,
  }: QueryFunctionContext<
    ReturnType<typeof queryKeys.taskItems.getTeamTaskItemSubtasks>
  >): Promise<GetTeamTaskItemsDto> {
    const accessToken = await getAccessToken();
    const [, teamSlug] = queryKey;

    if (taskItemGuid === undefined) {
      return {
        taskItems: [],
      };
    }

    const response = await fetch(
      `${configuration.apiRootUrl}/teams/${teamSlug}/task-items?parentTaskItemGuid=${taskItemGuid}`,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );

    if (!response.ok) {
      throw new FetchError(response);
    }

    return response.json();
  }

  return { getTeamTaskItemSubtasksRequest };
};

const useGetTeamTaskItemSubtasks = (teamSlug: string | undefined) => {
  const { getTeamTaskItemSubtasksRequest } = useGetTeamTaskItemSubtasksRequest();

  return useInfiniteQuery({
    queryKey: queryKeys.taskItems.getTeamTaskItemSubtasks(teamSlug),
    queryFn: getTeamTaskItemSubtasksRequest,
    enabled: teamSlug !== undefined,
  });
};

export { useGetTeamTaskItemSubtasks };
